import React, { Component, PropTypes } from 'react';
import Html from '../../Html';
import Accordion from '../../Accordion';
import { geti18n } from '../../../utils';

/**
 * Default Accordion is used on the Model and trim views in different locations, because they
 * are the same content and info they have been broken out into a separate component.
 */
class DefaultAccordions extends Component {
  static propTypes = {
    accordion0Title: PropTypes.string,
    accordion0Content: PropTypes.string,
    accordion1Title: PropTypes.string,
    accordion1Content: PropTypes.string
  }
  static defaultProps = {
    accordion0Title: geti18n('accordionDrawers.0.title'),
    accordion0Content: geti18n('accordionDrawers.0.content'),
    accordion1Title: geti18n('accordionDrawers.1.title'),
    accordion1Content: geti18n('accordionDrawers.1.content'),
  }
  render() {
    const {
      accordion0Content,
      accordion0Title,
      accordion1Content,
      accordion1Title
    } = this.props;
    return (
      <div>
        <Accordion title={accordion0Title} >
          <Html markup={accordion0Content} />
        </Accordion>
        <Accordion title={accordion1Title} open>
          <Html markup={accordion1Content} />
        </Accordion>
      </div>
    )
  }
}

export default DefaultAccordions;



/** WEBPACK FOOTER **
 ** ./src/components/Accordion/DefaultAccordions/index.js
 **/